
import http from "./http";

const apiEndpoint = process.env.REACT_APP_BASE_URL +  "/api/EntPatt";

export function getEntPatt(query) {
  return http.post(`${apiEndpoint}/GetTreeRep?search=${query}`);
}

